/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const ModalPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * Dialog content
   */
  content: PropTypes.object,

  /**
   * onClose callback
   */
  onClose: PropTypes.func,

  /**
   * open property of dialog
   */
  open: PropTypes.bool,

  /**
   * Title of the dialog
   */
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),

  /**
   * Width in pixels
   */
  width: PropTypes.string,
};

export default ModalPropTypes;
